<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    :loading="loading"
    @change="handleChange"
    placeholder="可多选"
    style="width: 100%"
    multiple
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name + (item.name_en ? `（${item.name_en}）` : '')"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { userListByAuthCode } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      value: [],
    },
    authCode: {
      type: String,
      default: '',
    },
    roleId: '',
  },
  data() {
    return {
      selected: [],
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  watch: {
    roleId: function () {
      this.requestData(true)
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(autoSelect = false) {
      this.loading = true
      let data = {
        auth_code: this.authCode,
        role_id: this.roleId,
      }

      let res = await userListByAuthCode(data)
      this.loading = false
      this.lists = res.data.list
      if (autoSelect && this.roleId) {
        let ids = this.lists.map((item) => {
          return item.id
        })
        this.$emit('input', ids)
      }
    },
  },
}
</script>